import { CollateralType } from '@app/configs/constants';
import handleApiErr from '@app/helper/handleApiErr';
import {
  getJourneyFromUserResponse,
  getPlatformFromUserResponse,
  refreshContactNumbersAfterUserApi,
} from '@app/services/contactNumbersBridge';
import { renewApplicationApi } from '@app/navigationApp';
import { getNextRoute } from '@app/navigationApp/navigationUtil';
import { updateLinkedApplication, updateUserDetails } from '@app/store/slices/authSlice';
import { updateReferralBanner } from '@app/store/slices/commonSlice';
import { updatePartnerParams } from '@app/store/slices/platformSlice';
import { ThemedView } from '@app/theme';
import { ThemedText } from '@app/theme/Components';
import ScreenWrapper from '@hoc/ScreenWrapper';
import AsyncStorage from "@react-native-async-storage/async-storage";
import { BottomTabScreenProps } from '@react-navigation/bottom-tabs';
import { useIsFocused } from '@react-navigation/native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { BottomTabParamList, PrivateStackParamList } from '@routes/types';
import { getEnabledRTA } from '@screens/KYCStepper/services/service';
import axios from 'axios';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, ScrollView } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { createShimmerPlaceholder } from 'react-native-shimmer-placeholder';
import { endpoints } from '../../api/apis';
import ROUTE from '../../navigationApp/routes';
import BottomSheetContainer from '../../sharedComponents/Bottomsheet/Bottomsheet';
import FadeInAnimation from '../../sharedComponents/FadinAnimation/FadinAnimation';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { showErrorSheet } from '../../store/slices/errorSlice';
import gs from '../../styles/globalStyles';
import { trackEvent } from '../../utils';
import { addSuffix, emailDefferingFlag } from '../../utils/utils';
import ReferralBanner from '../LMSDasboard/components/ReferralBanner';
import CheckEligibleCard from './components/CheckEligibleCard/CheckEligibleCard';
import ConfirmEditLimit from './components/CheckEligibleCard/ConfirmEditLimit';
import DownloadAppCard from './components/DownloadAppCard';
import FaqContainer from './components/FaqContainer/FaqContainer';
import DashboardHeader from './components/Header/Header';
import HorizontalScrollScreen from './components/HorizontalScrollScreen/HorizontalScrollScreen';
import InterestCalculatorCard from './components/InterestCalculatorCard/InterestCalculatorCard';
import { LimitResultCard } from './components/LimitResultCard/LimitResultCard';
import SectionHeading from './components/SectionHeading';
import WhyVoltSection from './components/WhyVolt';
import { getApplicationId } from '../FetchPortfolio/utils';

type DashboardScreenProps = NativeStackScreenProps<PrivateStackParamList, 'HOME'> | BottomTabScreenProps<BottomTabParamList, 'DASHBOARD_SCREEN'>;

const DashboardScreen = ({
  navigation,
  route,
}: DashboardScreenProps) => {
  const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);
  const userDetails = useAppSelector((state) => state.auth?.userDetails);
  const firebaseParams = useAppSelector((state) => state.firebaseParams);
  const [loading, setLoading] = useState<boolean>(true);
  const [pledgeDetails, setPledgeDetails] = useState<any>({});
  const [showEditLimit, setShowEditLimit] = useState<boolean>(false);
  const [isEditLimitBottomSheetVisible, setIsEditLimitBottomSheetVisible] =
    useState<boolean>(false);
  const [showInterestCalculator, setShowInterestCalculator] =
    useState<boolean>(false);
  const [initialDataLoading, setInitialDataLoading] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const auth = useAppSelector((state) => state.auth);
  const { showMyAccountIcon } = useAppSelector(state => state.platformParams)
  const { t } = useTranslation('translation', {
    keyPrefix: route?.name as String,
  });
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  const { isPLJ, isfromTDL } = useAppSelector((state) => state.platformParams)
  const referralBanner = useAppSelector((state) => state.commonReducer.referralBanner);
  const emailDefferingFeatureFlag = emailDefferingFlag();


  const isFocused = useIsFocused()


  const openEditLimitBottomSheet = () => {
    trackEvent('DASHBOARD_EDIT_LIMIT_PAGEVIEWED')
    setIsEditLimitBottomSheetVisible(true);
  };
  const closeBottomSheet = () => {
    setIsEditLimitBottomSheetVisible(false);
  };


  const ctaAction = async () => {

    try {
      setButtonLoader(true);
      let applicationId = auth?.userDetails?.linkedApplications[0]?.applicationId;
      let applicationIdStored = await getApplicationId(applicationId);

      let updateUserInfo;
      try {
        updateUserInfo = await axios.post(endpoints.userInfo, {
          onboardingPartnerCode: '',
        });
      } finally {
        await refreshContactNumbersAfterUserApi(
          updateUserInfo?.data
            ? {
                journey: getJourneyFromUserResponse(updateUserInfo.data),
                platform: getPlatformFromUserResponse(updateUserInfo.data),
              }
            : undefined,
        );
      }

      const updatedApplicationResponse = updateUserInfo?.data?.linkedApplications[0];
      dispatch(updateUserDetails(updateUserInfo?.data))
      dispatch(updateLinkedApplication(updatedApplicationResponse))

      const renewAppliationResponse = await renewApplicationApi({ applicationId: applicationId });
      dispatch(updateLinkedApplication(renewAppliationResponse));

      let Route = renewAppliationResponse?.currentStepId;
      const collateralType = renewAppliationResponse?.assetCategory?.toUpperCase();

      if (Route === ROUTE.MF_PLEDGE_PORTFOLIO && collateralType === CollateralType.SHARES) {
        navigation.navigate(ROUTE.PLEDGE_CONFIRMATION);
        return;
      }
      // remove this in prod release
      if (emailDefferingFeatureFlag === false) {
        if (
          updateUserInfo?.data?.linkedBorrowerAccounts[0]?.accountHolderEmail === null
        ) {
          Route = isPLJ ? ROUTE.ENTER_EMAIL : ROUTE.VERIFY_EMAIL
        }
      }
      const enabledRTA = await getEnabledRTA({
        applicationId: updatedApplicationResponse?.applicationId
      })
      if (enabledRTA?.mfcFetchStatus === 'IN_PROGRESS') {
        navigation.navigate('MFC_FETCH_EVALUTE_FUNDS')
        return;
      }
      setTimeout(() => {
        if (Route) {

          let nextRoute = getNextRoute(Route, updatedApplicationResponse?.applicationState, updatedApplicationResponse?.stepStatusMap, enabledRTA?.enabledRtaFlow, "HOME");
          // @ts-ignore
          navigation.navigate(nextRoute);
        }
        setButtonLoader(false);
      }, 200);
    } catch (err: any) {
      setButtonLoader(false);
      if (handleApiErr(err)) {
        dispatch(showErrorSheet({
          isErrorSheetVisible: true,
          errorMessage: err?.data?.message,
          closeOnBackdropPress: true,
          errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
          errorHeading: err?.data?.header,
          showErrorHeading: true,
          btnName: 'Ok, got it!',
        }))
      }
    } finally {
      setButtonLoader(false);
    }
  };


  const fetchShowEditLimit = () => {
    const accountId = auth?.userDetails?.linkedApplications[0]?.accountId;
    const url = endpoints.showEnableLimit + accountId;
    axios
      .get(url)
      .then(res => {
        setShowEditLimit(res?.data?.isEnabled);
      })
      .catch(err => {
        console.log('showEditLimit error', err, url);
      });
  };

  const fetchPlatformConfig = () => {
    const url = endpoints.platformDetailsApi;
    axios
      .get(url)
      .then(res => {
        setShowInterestCalculator(
          res?.data?.platformSDKConfig?.showInterestCalculator,
        );
      })
      .catch(err => {
        console.log('platform config error', err);
      });
  };

  const fetchReferralBanner = () => {
    const borrowerId = userDetails?.linkedBorrowerAccounts?.[0]?.accountId;
    if (!borrowerId) return;
    const url = `${endpoints.referralBanner}${borrowerId}/banner`;
    axios.get(url)
      .then((res) => {
        dispatch(updateReferralBanner(res?.data ?? null));
      })
      .catch(() => {
        // Silently fail — banner is non-critical
      });
  };

  const fetchPledgeLimit = () => {
    const applicationId =
      auth?.userDetails?.linkedApplications[0]?.applicationId;
    const url = endpoints.pledgeData + applicationId;
    axios
      .get(url)
      .then(res => {
        const pledgeLimitResponse = res.data;
        const stepResponseObject = pledgeLimitResponse?.stepResponseObject;
        const repositoryAssetMetadataMap =
          pledgeLimitResponse?.stepResponseObject?.repositoryAssetMetadataMap;
        const creditLimit =
          (stepResponseObject?.approvedCreditLimit || 0) +
          (stepResponseObject?.requestCreditLimit || 0);
        const camsDate = repositoryAssetMetadataMap?.CAMS.casFetchDate;
        const karvyDate = repositoryAssetMetadataMap?.KARVY.casFetchDate;
        const latestDate = Math.max(camsDate, karvyDate);

        const karvyDateToShow = moment.unix(latestDate).format('DD-MM-yyyy');
        const displayDate = karvyDateToShow.substring(0, 2);
        const dateName = `${displayDate}${addSuffix(displayDate)}`;
        const monthName = moment.unix(Number(latestDate)).format('MMM');
        const yearName = karvyDateToShow.slice(-4);
        let lastEditDate = `${dateName} ${monthName} ${yearName}`;
        let creditLimitAmount = 0;
        if (stepResponseObject) {
          if (creditLimit != null && creditLimit > 0) {
            creditLimitAmount = creditLimit;
          } else {
            creditLimitAmount = 0;
          }
        }
        setPledgeDetails({ creditLimitAmount, lastEditDate });
        dispatch(updatePartnerParams({ showCall: stepResponseObject?.availableCreditLimit >= (stepResponseObject?.minimumEligibleLimit?.amount || 0) }))
      })
      .catch(err => {
        console.log('pledgle limit error', err);
      })
      .finally(() => {
        setLoading(false);
      });
  };


  const continueEditLimitAction = async () => {
    setButtonLoader(true);
    let applicationId = auth?.userDetails?.linkedApplications[0]?.applicationId;
    const url = endpoints.editLimitRoute + applicationId;
    const enabledRTA = await getEnabledRTA({
      applicationId: auth?.userDetails?.linkedApplications[0]?.applicationId
    })
    if (enabledRTA?.mfcFetchStatus === 'IN_PROGRESS') {
      navigation.navigate('MFC_FETCH_EVALUTE_FUNDS')
      return;
    }
    axios
      .get(url)
      .then(res => {
        setIsEditLimitBottomSheetVisible(false)
        if (enabledRTA.enabledRtaFlow === "MfCentralFlow") {
          navigation.navigate(ROUTE.MFC_FETCH_ANCHOR)
        } else {
          const currentStepId = res.data.updatedApplicationObj.currentStepId;
          navigation.navigate(currentStepId);
        }
      })
      .catch(err => {
        setIsEditLimitBottomSheetVisible(false)
        if (handleApiErr(err)) {
          setTimeout(() => {
            dispatch(
              showErrorSheet({
                isErrorSheetVisible: true,
                errorMessage: err?.data?.message,
                closeOnBackdropPress: true,
                errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
                ctaLabel: 'Okay'
              }),
            );
          }, Platform.OS === 'ios' ? 500 : 0)
        }


      })
      .finally(() => {
        setButtonLoader(false);
      });
  };

  const fetchInitialData = useCallback(async () => {
    try {
      await Promise.all([
        fetchPledgeLimit(),
        fetchShowEditLimit(),
        fetchPlatformConfig(),
        fetchReferralBanner()
      ]);
    } catch (error) {
      console.error('Error fetching initial data:', error);
    }
  }, []);


  useEffect(() => {
    if (auth.isAuthenticated && auth.userDetails !== null) {
      fetchInitialData();
    }
  }, [auth.isAuthenticated]);

  useEffect(() => {
    return () => {
      fetchShowEditLimit()
    }
  }, [isFocused])




  const { creditLimitAmount, lastEditDate } = pledgeDetails;
  return (
    <>
      <ScreenWrapper screenName={route?.name} additionalProperties={{ newArchRoute: true }}>
        <DashboardHeader
          callDataVisible={creditLimitAmount > 0}
          showMyAccountIcon={showMyAccountIcon}
          navigation={navigation}
          name={auth?.userDetails?.user?.fullName?.split(' ')[0] ?? ''}
        />
        <ScrollView>

          <ThemedView flex={1} backgroundColor="bg-surface-page">
            {/* {
              Dimensions.get('window').width < 765 &&
              <InstaStory
                data={StoryData}
                duration={10}
                style={Platform.OS !== 'web' ? ls.instaStoryContainer : {
                  marginTop: 24,

                }}
                avatarWrapperStyle = {Platform.OS !== 'web' ? ls.wrapper : {
                  ...Platform.OS === 'web' && !isMobile(getScreenType(Dimensions.get('window').width)) ? {width: 508/5} : {width: Dimensions.get('window').width/4.5},
                }}
                avatarTextStyle = {Platform.OS !== 'web' ? ls.wrapper : {
                  ...Platform.OS === 'web' && !isMobile(getScreenType(Dimensions.get('window').width)) ? {width: 508/7} : {width: Dimensions.get('window').width/6.5},
                  marginLeft:12,
                  alignItems:'center',
                  color:'#667085'
                }}
                unPressedBorderColor='transparent'
                pressedBorderColor='transparent'
                pressedAvatarTextColor='#667085'
                unPressedAvatarTextColor='#667085'
                storyImageStyle = {ls.storyImageStyle}
              />
            } */}
            {loading ? (
              <ShimmerPlaceholder
                // stopAutoRun
                style={{
                  width: '50%',
                  height: 24,
                  marginTop: 24,
                  borderRadius: 8,
                  marginHorizontal: 16,
                }}
              />
            ) : (
              creditLimitAmount > 0 && (
                <FadeInAnimation delay={100} duration={1000}>
                  <ThemedText mx="lg" mt="2xl" variant="b2b" color="text-primary">
                    Your instant cash is ready
                  </ThemedText>
                </FadeInAnimation>
              )
            )}
            {loading && (
              <ThemedView
                style={{
                  padding: 16,
                  borderRadius: 8,
                  backgroundColor: '#ddd',
                  marginTop: 24,
                  marginHorizontal: 16,
                }}>
                <ShimmerPlaceholder
                  style={[
                    gs.setWidth('100%'),
                    gs.setHeight(180),
                    {
                      borderRadius: 8,
                    },
                  ]}
                />
              </ThemedView>
            )}
            {!loading && creditLimitAmount > 0 ? (
              <LimitResultCard
                amount={creditLimitAmount}
                showEditLimit={showEditLimit}
                lastEditDate={lastEditDate}
                ctaAction={ctaAction}
                editLimitAction={openEditLimitBottomSheet}
                buttonLoader={buttonLoader}
                urlParams={{ isPLJ, isfromTDL }}
              />
            ) : (
              !loading && (
                <CheckEligibleCard
                  ctaAction={ctaAction}
                  t={t}
                  buttonLoader={buttonLoader}
                  urlParams={{ isPLJ, isfromTDL }}
                />
              )
            )}
             {referralBanner && referralBanner.length > 0 && (
              <ThemedView mx="lg" mb="lg">
                <ReferralBanner
                  banners={referralBanner}
                  navigation={navigation}
                  onBannerView={(banner, position) =>
                    trackEvent('LOS_HOME_REFERRAL_BANNER_VIEWED', {
                      source_page: route?.name,
                      banner_position: position,
                      platform: Platform.OS,
                    })
                  }
                  onBannerClick={() =>
                    trackEvent('LOS_HOME_REFERRAL_BANNER_CLICKED', {
                      source_page: route?.name,
                      platform: Platform.OS,
                    })
                  }
                />
              </ThemedView>
            )}
            {Platform.OS === 'web' && <DownloadAppCard />}
            <SectionHeading heading={'Why Volt Money you ask?'} />
            <WhyVoltSection />
            {showInterestCalculator && (
              <InterestCalculatorCard navigation={navigation} />
            )}

            <SectionHeading heading={'Learn about Loan against MF'} />
            <HorizontalScrollScreen />
            <FaqContainer navigation={navigation} />
          </ThemedView>
        </ScrollView>
        <BottomSheetContainer
          isVisible={isEditLimitBottomSheetVisible}
          close={closeBottomSheet}
          closeOnBackdropPress={true}
          borderTopRightRadius={10}
          borderTopLeftRadius={10}
          containerStyle={gs.setBg('#fefefe')}>
          <ConfirmEditLimit
            onClose={closeBottomSheet}
            buttonLoader={buttonLoader}
            ctaAction1={continueEditLimitAction}
            ctaAction2={closeBottomSheet}
          />
        </BottomSheetContainer>
      </ScreenWrapper>
    </>
  );
};

export default DashboardScreen;
